import script from "./AnalyticPermitionsTab.vue?vue&type=script&setup=true&lang=ts"
export * from "./AnalyticPermitionsTab.vue?vue&type=script&setup=true&lang=ts"

import "./AnalyticPermitionsTab.vue?vue&type=style&index=0&id=3c3f3eac&scoped=true&lang=scss"
import "./AnalyticPermitionsTab.vue?vue&type=style&index=1&id=3c3f3eac&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c3f3eac"]])

export default __exports__